import CustomModal from 'components/global/CustomModal'
import React from 'react'
import AddShifts from '../ModalCotent/MentorRequest/AddShifts/AddShifts'
import { DateShift } from 'types/mentorRequest/mentorRequest'
import CustomModalFooter from 'components/global/CustomModalFooter'

interface AddShiftModalProps {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  mentorShifts: DateShift[]
  setMentorShifts: React.Dispatch<React.SetStateAction<DateShift[]>>
}

const AddShiftModal: React.FC<AddShiftModalProps> = ({
  openModal,
  setOpenModal,
  mentorShifts,
  setMentorShifts,
}) => {
  const handleClose = () => {
    setOpenModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={openModal}
        isCloseModalCustom={true}
        closeModal={handleClose}
        title="Add Shift"
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Save"
            btnType="primary"
            closeModal={handleClose}
            onSubmit={handleClose}
          />
        }
      >
        <AddShifts
          mentorShifts={mentorShifts}
          setMentorShifts={setMentorShifts}
        />
      </CustomModal>
    </>
  )
}

export default AddShiftModal
